import type { ConstituentPageProcessing } from '@avisoma/shared';

export type ConstituentPageBucket = 'errors' | 'in-progress' | 'done';

const STAGES = ['pdfParser', 'metadata', 'embeddings', 'classification', 'dataExtraction'] as const;

/** Bucket one constituent page by its processing JSON. Errors win over
 * in-progress when both apply on the same page; all-done means every stage is
 * terminal-good (done or skip). Used by the ConstituentPagesCard chip filter. */
export function classifyConstituentPage(processing: ConstituentPageProcessing): ConstituentPageBucket {
  const hasError = STAGES.some((s) => processing[s]?.status === 'error');
  if (hasError) return 'errors';

  const hasUnfinished = STAGES.some((s) => {
    const status = processing[s]?.status;
    return status === 'processing' || status === 'pending' || status === undefined;
  });
  return hasUnfinished ? 'in-progress' : 'done';
}
